/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'cloud-connector-user';
const componentName = 'vcenter-credentials';
const prefix = `${moduleName}.${componentName}`;

export const usernameFieldLabel = `${prefix}.usernameFieldLabel`;
export const passwordFieldLabel = `${prefix}.passwordFieldLabel`;
export const usernameFieldPlaceholder = `${prefix}.usernameFieldPlaceholder`;
export const passwordFieldPlaceholder = `${prefix}.passwordFieldPlaceholder`;

export const ENGLISH = {
    [usernameFieldLabel]: 'Username',
    [passwordFieldLabel]: 'Password',
    [usernameFieldPlaceholder]: 'Enter Username',
    [passwordFieldPlaceholder]: 'Enter Password',
};
